<div class="mtx-calendar-header">
  <button *ngIf="type !== 'time'"
          mat-button type="button" class="mtx-calendar-header-year"
          [class.active]="currentView === 'year' || currentView === 'multi-year'"
          [attr.aria-label]="_yearButtonLabel"
          (click)="_yearClicked()">
    <span>{{ _yearButtonText }}</span>
    <svg *ngIf="multiYearSelector || type === 'year'"
         class="mtx-calendar-header-year-dropdown" matButtonIcon iconPositionEnd
         width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M7,10L12,15L17,10H7Z"></path>
    </svg>
  </button>
  <div *ngIf="type !== 'year'" class="mtx-calendar-header-date-time">
    <button *ngIf="type !== 'time'"
            mat-button type="button" class="mtx-calendar-header-date"
            [class.active]="currentView === 'month'"
            [class.not-clickable]="type === 'month'"
            [attr.aria-label]="_dateButtonLabel"
            (click)="_dateClicked()">{{ _dateButtonText }}</button>
    <span *ngIf="type.endsWith('time')" class="mtx-calendar-header-time"
          [class.active]="currentView === 'clock'">
      <span class="mtx-calendar-header-hour-minute-container">
        <button mat-button type="button" class="mtx-calendar-header-hours"
                [class.active]="_clockView === 'hour'"
                [attr.aria-label]="_hourButtonLabel"
                (click)="_hoursClicked()">{{ _hoursButtonText }}</button>
        <span class="mtx-calendar-header-hour-minute-separator">:</span>
        <button mat-button type="button" class="mtx-calendar-header-minutes"
                [class.active]="_clockView === 'minute'"
                [attr.aria-label]="_minuteButtonLabel"
                (click)="_minutesClicked()">{{ _minutesButtonText }}</button>
      </span>
      <span *ngIf="twelvehour" class="mtx-calendar-header-ampm-container">
        <button mat-button type="button" class="mtx-calendar-header-ampm"
                [class.active]="_AMPM === 'AM'" aria-label="AM"
                (click)="_ampmClicked('AM')">AM</button>
        <button mat-button type="button" class="mtx-calendar-header-ampm"
                [class.active]="_AMPM === 'PM'" aria-label="PM"
                (click)="_ampmClicked('PM')">PM</button>
      </span>
    </span>
  </div>
</div>

<div class="mtx-calendar-content" [ngSwitch]="currentView">
  <div *ngIf="currentView === 'month' || currentView === 'year' || currentView === 'multi-year'"
       class="mtx-month-content">
    <div class="mtx-calendar-controls">
      <button mat-icon-button type="button"
              class="mtx-calendar-previous-button"
              [class.disabled]="!_previousEnabled()"
              [attr.aria-disabled]="!_previousEnabled()"
              [attr.aria-label]="_prevButtonLabel"
              (click)="_previousClicked()">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </svg>
      </button>
      <div class="mtx-calendar-period-button"
           [@slideCalendar]="_calendarState"
           (@slideCalendar.done)="_calendarStateDone()">
        <strong>{{ _yearPeriodText }}</strong>
      </div>
      <button mat-icon-button type="button"
              class="mtx-calendar-next-button"
              [class.disabled]="!_nextEnabled()"
              [attr.aria-disabled]="!_nextEnabled()"
              [attr.aria-label]="_nextButtonLabel"
              (click)="_nextClicked()">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
        </svg>
      </button>
    </div>
  </div>
  <mtx-month-view *ngSwitchCase="'month'"
                  (_userSelection)="_userSelected()"
                  (selectedChange)="_dateSelected($event)"
                  [activeDate]="_activeDate"
                  [dateFilter]="_dateFilterForViews"
                  [selected]="selected!"
                  [type]="type">
  </mtx-month-view>
  <mtx-year-view *ngSwitchCase="'year'"
                 (_userSelection)="_userSelected()"
                 (selectedChange)="_monthSelected($event)"
                 [activeDate]="_activeDate"
                 [dateFilter]="_dateFilterForViews"
                 [selected]="selected!"
                 [type]="type">
  </mtx-year-view>
  <mtx-multi-year-view *ngSwitchCase="'multi-year'"
                       (_userSelection)="_userSelected()"
                       (selectedChange)="_yearSelected($event)"
                       [activeDate]="_activeDate"
                       [dateFilter]="_dateFilterForViews"
                       [maxDate]="maxDate"
                       [minDate]="minDate"
                       [selected]="selected!"
                       [type]="type">
  </mtx-multi-year-view>

  <ng-container *ngSwitchDefault>
    <mtx-time *ngIf="timeInput; else clock"
              (_userSelection)="_userSelected()"
              (activeDateChange)="_onActiveDateChange($event)"
              (selectedChange)="_timeSelected($event)"
              [AMPM]="_AMPM"
              (ampmChange)="_ampmClicked($event)"
              [clockView]="_clockView"
              (clockViewChange)="_clockView = $event"
              [twelvehour]="twelvehour"
              [dateFilter]="dateFilter"
              [interval]="timeInterval"
              [maxDate]="maxDate"
              [minDate]="minDate"
              [selected]="_activeDate">
    </mtx-time>

    <ng-template #clock>
      <mtx-clock (_userSelection)="_userSelected()"
                 (activeDateChange)="_onActiveDateChange($event)"
                 (selectedChange)="_dialTimeSelected($event)"
                 [AMPM]="_AMPM"
                 [dateFilter]="dateFilter"
                 [interval]="timeInterval"
                 [maxDate]="maxDate"
                 [minDate]="minDate"
                 [selected]="_activeDate"
                 [startView]="_clockView"
                 [twelvehour]="twelvehour">
      </mtx-clock>
    </ng-template>
  </ng-container>
</div>
